import { AppTour } from '../tour.model';

export const INTEGRATION_INTRO_TOUR: AppTour = {
  tourId: 'integration-intro-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'integration-function-intro-tour',
      attachTo: { element: '#function-guide-29', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_integration_intro_title',
      text: 'tour_integration_intro_text',
      buttons: [
        { text: 'tour_label_done', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
    }
  ]};

